__webpack_require__.p = "/qr-code/";